import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseSystemsStepsWorker } from '../workers/systems.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseSystemsSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseSystemsStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseSystemsStepsWorker | Remote<WarehouseSystemsStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/systems.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseSystemsStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseSystemsStepsWorker()];
  }
}

export class WarehouseDownloadSystemsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_SYS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download systems sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseSystemsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanSystemsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_SYS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean systems sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseSystemsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehousePushSystemsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_SYS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing push systems sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseSystemsSyncWorkerFactory(), taskBreaker);
  }
}
